// extracted by mini-css-extract-plugin
export default {"listContainer":"List_listContainer__9UxwW","emptyListText":"List_emptyListText__h0Ego"};